import { initHome } from './modules/home.js';
import { initSpots } from './modules/spots.js';
import { initSpotDetail } from './modules/spotDetail.js';
import { initActivitiesDetail } from './modules/activitiesDetail.js';
import { initFeaturesDetail } from './modules/featuresDetail.js';
import { initCoursesDetail } from './modules/coursesDetail.js';
import { initAreasDetail } from './modules/areasDetail.js';
import { initAccess } from './modules/access.js';
import { initRelated } from './modules/related.js';
import { initGourmetDetail } from './modules/gourmetDetail.js';
import { initGourmetFeatures } from './modules/gourmetFeatures.js';
import { initStayDetail } from './modules/stayDetail.js';
import { initTransportationDetail } from './modules/transportationDetail.js';
import { initArchive } from './modules/archive.js';
import { initFaq } from './modules/faq.js';
import { initBusinessNewsDetail } from './modules/businessNewsDetail.js';

// jQueryが読み込まれた後に実行
jQuery(function ($) {

  /** 同一ページ内のアンカーリンクかどうかを判定 */
  const isSamePageAnchor = (href) => {
    if (!href) return false;
    if (href.startsWith('#')) return true;

    try {
      const url = new URL(href, window.location.href);
      return (
        url.pathname === window.location.pathname &&
        url.search === window.location.search &&
        url.hash !== ''
      );
    } catch (e) {
      return false;
    }
  };

  /** SPメニューを閉じる */
  const closeSpMenu = () => {
    $('body').removeClass('is-slidedown');
    $('.p-header__button').removeClass('active');
  };

  /**
   * ハンバーガーメニュー
   */
  $('.p-header__button').on('click', function () {
    $('body').toggleClass('is-slidedown');
    $(this).toggleClass('active');
  });

  /**
   * SP時にメニュー内のアンカーリンクを踏んだらメニューを閉じる
   */
  $('.p-header__nav').on('click', 'a', function () {
    const href = $(this).attr('href') || '';
    if (window.matchMedia('(max-width: 1024px)').matches && isSamePageAnchor(href)) {
      closeSpMenu();
    }
  });

  /**
   * スクロール時にヘッダーにボックスシャドウを追加
   */
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 5) {
      $('.p-header').addClass('is-scrolled');
    } else {
      $('.p-header').removeClass('is-scrolled');
    }
  });

  /**
   * フッターの住所を郵便番号の後で改行（スマホのみ）
   */
  if ($(window).width() < 769) {
    $('.p-footer__site-address div').each(function () {
      const text = $(this).html();
      // 郵便番号パターン（〒xxx-xxxx）の後の全角・半角スペースを<br>に置換
      const newText = text.replace(/(〒\d{3}-\d{4})[\s　]+/, '$1<br>');
      if (text !== newText) {
        $(this).html(newText);
      }
    });
  }

  /**
   * エリアタイトルの読点の後で改行（スマホのみ）
   */
  if ($(window).width() < 769) {
    $('.s-home__areas .c-label__archive--title').each(function () {
      const text = $(this).html();
      // 「、」の後に<br>を挿入
      const newText = text.replace(/、/g, '、<br>');
      if (text !== newText) {
        $(this).html(newText);
      }
    });
  }

  /**
   * 各ページの初期化
   */
  initHome($);
  initSpots($);
  initSpotDetail($);
  initActivitiesDetail($);
  initFeaturesDetail($);
  initCoursesDetail($);
  initAreasDetail($);
  initAccess($);
  initRelated($);
  initGourmetDetail($);
  initGourmetFeatures($);
  initStayDetail($);
  initTransportationDetail($);
  initArchive($);
  initFaq($);
  initBusinessNewsDetail($);
});
